import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { oneloginUrl, oneloginPostLogouturl } from '../constants/config';

// App imports
import { LOGOUT_URL } from '../constants/AppApiConstants';
import { SERVICE_NAME } from '../constants/AppConstants';
import { SIGN_IN_URL } from '../constants/AppUrlConstants';
import Auth from '../utils/Auth';
import { navigateTo, navigateHref } from '../utils/navigation';

const Nav = () => {
  const { pathname } = useLocation();
  const serviceName = SERVICE_NAME;
  const [navArray, setNavArray] = useState([]);
  const [menuState, setMenuState] = useState(true);

  const menuToggle = (e) => {
    e.preventDefault();
    setMenuState(!menuState);
  };

  const navData = [
    {
      id: 'VoyagePlans',
      urlStem: '/voyage-plans',
      text: 'Voyage Plans',
      active: false,
    },
    {
      id: 'PleasureCrafts',
      urlStem: '/pleasure-crafts',
      text: 'Pleasure Crafts',
      active: false,
    },
    {
      id: 'People',
      urlStem: '/people',
      text: 'People',
      active: false,
    },
    {
      id: 'Account',
      urlStem: '/account',
      text: 'Account',
      active: false,
    },
    {
      id: 'Help',
      urlStem: '/page/help',
      text: 'Help',
      active: false,
    },
  ];

  const setActivePage = (url) => {
    const tempArr = [...navData];
    const newArray = tempArr.map((elem) => {
      const currentUrl = !url ? elem.urlStem : url;
      if (currentUrl === elem.urlStem) {
        return { ...elem, active: true };
      }
      return { ...elem, active: false };
    });
    document.activeElement.blur();
    setNavArray(newArray);
  };

  const handleSignout = async () => {
    const idToken = Auth.retrieveIdToken();
    const oneLoginLogoutUrl = `${oneloginUrl}/logout?id_token_hint=${encodeURIComponent(idToken)}&post_logout_redirect_uri=${oneloginPostLogouturl}${SIGN_IN_URL}`;
    try {
      const controller = new AbortController();
      const { signal } = controller;
      const response = await axios.post(
        LOGOUT_URL,
        {},
        {
          signal,
          headers: { Authorization: `Bearer ${Auth.retrieveToken()}` },
        },
      );
      if (response.status === 200) {
        setActivePage('/voyage-plans');
        Auth.logout();
        navigateTo(oneLoginLogoutUrl);
      }
    } catch {
      setActivePage('/voyage-plans');
      Auth.logout();
      navigateHref(oneLoginLogoutUrl);
    } finally {
      sessionStorage.removeItem('page'); // removes the page stored so when user signs in it reverts to page 1
      sessionStorage.removeItem('isNewUser'); // Remove the “new user” flag so it resets on the user’s next login
    }
  };

  useEffect(() => {
    setActivePage(pathname);
  }, [pathname]);

  return (
    <div className="govuk-header__content">
      <Link
        className="govuk-header__link govuk-header__service-name"
        to="/"
        data-testid="serviceName"
      >
        {serviceName}
      </Link>

      {Auth.isAuthorized() && (
        <nav aria-label="Menu" className="govuk-header__navigation ">
          <button
            type="button"
            onClick={(e) => menuToggle(e)}
            className={
              !menuState
                ? 'govuk-header__menu-button govuk-js-header-toggle govuk-header__menu-button--close'
                : 'govuk-header__menu-button govuk-js-header-toggle govuk-header__menu-button--open'
            }
            aria-controls="navigation"
            aria-label="Show or hide navigation menu"
            aria-expanded={menuState}
          >
            Menu
          </button>
          <ul
            id="navigation"
            className={
              !menuState
                ? 'govuk-header__navigation-list govuk-visually-hidden'
                : 'govuk-header__navigation-list govuk-header__navigation-list--open'
            }
            aria-label="Top Level Navigation"
          >
            {navArray.map((elem) => {
              const activeState = elem.active
                ? 'govuk-header__navigation-item govuk-header__navigation-item--active'
                : 'govuk-header__navigation-item';
              return (
                <li className={activeState} key={elem.urlStem} data-testid={`listitem-${elem.id}`}>
                  <Link
                    to={elem.urlStem}
                    className="govuk-header__link"
                    onClick={() => setActivePage(elem.urlStem)}
                  >
                    {elem.text}
                  </Link>
                </li>
              );
            })}
            <li className="govuk-header__navigation-item">
              <a href="#sign-out" className="govuk-header__link" onClick={() => handleSignout()}>
                Sign out
              </a>
              {/* Link tag cannot be used as we do not have a signout route */}
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};

export default Nav;
